module.exports = __webpack_public_path__ + "h5-static/img/lijianjin.98ea077f.png";